import api from '../baseApi.js'
import { unwrap } from '../helpers.js'

export const uploadApi = {
  uploadFile: (formData) =>
    api.post('/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then(unwrap),
}
